"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _recoil = require("recoil");

var _store = require("../store");

var useActiveView = function useActiveView(name) {
  var _useRecoilState = (0, _recoil.useRecoilState)(_store.viewState),
      _useRecoilState2 = (0, _slicedToArray2["default"])(_useRecoilState, 2),
      currentView = _useRecoilState2[0],
      setNewView = _useRecoilState2[1];

  var _useRecoilState3 = (0, _recoil.useRecoilState)(_store.returnState),
      _useRecoilState4 = (0, _slicedToArray2["default"])(_useRecoilState3, 2),
      returnPage = _useRecoilState4[0],
      setReturnPage = _useRecoilState4[1];

  var setCurrentView = function setCurrentView(view) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    if ('returnPage' in options) {
      setReturnPage(options.returnPage);
    }

    setNewView(view);
  };

  var active = currentView === name;
  return {
    active: active,
    currentView: currentView,
    setCurrentView: setCurrentView,
    returnPage: returnPage,
    setReturnPage: setReturnPage
  };
};

var _default = useActiveView;
exports["default"] = _default;